import { motion } from 'motion/react'

import { withPublicImageUrl } from '@lib/utils/cdn'

import { AnimationStage } from './constants'

import style from './vbar-card.module.scss'

export function VbarCard({
  stage,
  cardDismissed,
  buttonPressed,
}: {
  stage: AnimationStage
  cardDismissed: boolean
  buttonPressed: boolean
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: '100%' }}
      animate={{
        opacity: stage === AnimationStage.VbarCard && !cardDismissed ? 1 : 0,
        y: stage === AnimationStage.VbarCard && !cardDismissed ? '0%' : '100%',
      }}
      transition={{
        y: { ease: [0.4, 0, 0.2, 1], duration: 0.5 },
        opacity: { duration: 0.4, delay: cardDismissed ? 0 : 0.2 },
      }}
      className={style.vbarCard}
      style={{
        backgroundImage: `url(${withPublicImageUrl('intro-proofreader-vbar-card.svg')})`,
        display: stage === AnimationStage.VbarCard && !cardDismissed ? 'block' : 'none',
      }}
    >
      <div className={style.cardButtons}>
        <motion.div
          className={style.acceptButton}
          animate={{ scale: buttonPressed ? [1, 0.7, 1] : 1 }}
          transition={{ duration: 0.4, times: [0, 0.3, 0.7], ease: 'easeInOut' }}
          style={{
            backgroundImage: `url(${withPublicImageUrl('intro-proofreader-vbar-card-accept.svg')})`,
          }}
        />
        <div
          className={style.dismissButton}
          style={{
            backgroundImage: `url(${withPublicImageUrl('intro-proofreader-vbar-card-dismiss.svg')})`,
          }}
        />
      </div>
    </motion.div>
  )
}
